import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3520238999/src/covid-frontend/components/getting-started.tsx");
